import React, { useState, useEffect } from 'react';
import { Alert } from 'react-bootstrap';
import { Auth } from 'aws-amplify';
import { useNavigate } from 'react-router-dom';
import AskQuestion from '../components/AskQuestion';
import {SimpleSection} from '../components/Section';
import LoadingSpinner from '../components/LoadingSpinner';

const AskPage = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    checkAuthStatus();
  }, []);

  async function checkAuthStatus() {
    try {
      await Auth.currentAuthenticatedUser();
      setIsAuthenticated(true);
    } catch (error) {
      setIsAuthenticated(false);
    } finally {
      setLoading(false);
    }
  }

  if (loading) {
    return <LoadingSpinner message="Loading question form..." />;
  }

  if (!isAuthenticated) {
    return (
      <SimpleSection>
        <Alert variant="warning">
          <Alert.Heading>Login Required</Alert.Heading>
          <p>
            You need to be logged in to ask a question. Please go to the{' '}
            <Alert.Link onClick={() => navigate('/user')}>
              user page
            </Alert.Link>{' '}
            to sign in or register.
          </p>
        </Alert>
      </SimpleSection>
    );
  }

  return (<>
    <SimpleSection>
      <h2 className="mb-4">Ask a Question</h2>
      <p className="mb-4">
        Have a question about the Quantum City Challenge? We're here to help! Fill out the form below and our team will respond as soon as possible.
      </p>
    </SimpleSection>
    <SimpleSection>
      <AskQuestion />
    </SimpleSection>
  </>);
};

export default AskPage;
